import React, { useRef } from 'react';
import { KeyboardAvoidingView, View, } from 'react-native';
import { rem } from 'design-system';
import { useAutoFocusInput } from 'hooks/useAutoFocusInput';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import TextInput from 'utils/packages/TextInput';
import useColors from 'hooks/useColors';
import { styles as textStyles } from 'design-system/Text';
import { useHeaderHeight } from 'hooks';
import { useMarginBottom } from 'hooks/useMarginBottom';
import { HEIGHT } from 'design-system/Button';
import { KeyboardAvoidingButton } from 'design-system/KeyboardAvoidingButton';
const NthWorkingDayView = ({ value, onChange, onPress, bottomText, }) => {
    const styles = useStyles(styleSet);
    const colors = useColors();
    const inputRef = useRef(null);
    useAutoFocusInput(inputRef);
    const headerHeight = useHeaderHeight();
    const bottom = useMarginBottom('marginBottom');
    return (<>
      <KeyboardAvoidingView behavior="padding" pointerEvents="box-none" style={[styles.container, bottom]} keyboardVerticalOffset={headerHeight}>
        <TextInput ref={inputRef} value={value} onChangeText={onChange} selectionColor={colors.elements.brandMedium} keyboardType="number-pad" maxLength={1} style={styles.input}/>
        <View style={styles.bottomText}>{bottomText}</View>
      </KeyboardAvoidingView>
      <KeyboardAvoidingButton withFrame={false} title="Continue" disabled={!value || value === '0' || Number(value) > 5} brand onPress={onPress}/>
    </>);
};
const styleSet = createStyleSheets((colors) => ({
    input: {
        ...textStyles.Text_24,
        borderWidth: rem(1),
        color: colors.elements.brand,
        borderRadius: rem(8),
        paddingVertical: rem(8),
        paddingHorizontal: rem(16),
        // caretColor: colors.elements.brandMedium,
        backgroundColor: colors.cards.onDark,
        borderColor: colors.elements.brand,
        width: rem(56),
        height: rem(56),
        textAlign: 'center',
        alignSelf: 'center',
        justifyContent: 'center',
    },
    focusedStyles: {},
    container: {
        flex: 1.5,
        justifyContent: 'space-between',
    },
    bottomText: {
        marginBottom: HEIGHT + rem(32),
        paddingHorizontal: rem(16),
    },
}));
export default NthWorkingDayView;
